import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LanguageRegionMap } from 'src/app/types';
import { AuthService } from '../services/auth/auth.service';
import { TranslateService } from '../services/translation/translate.service';

@Injectable({
  providedIn: 'root',
})
export class AccountCompletionGuard {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private Auth: AuthService,
  ) {}

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree
  > {

    await this.Auth.reloadAuthData();
    if ( this.Auth.verifyProcessPending()) {
      const lang = this.translate.language as LanguageRegionMap;
      this.router.navigateByUrl(`/${lang}/validate`);
    }
    return true;
  }
}
